import { closeSentence, fallbackOf, fillRiskTemplate, isNewerVersion, partsOf, present, riskCopy, sourceField, summaryClause, UNKNOWN_VERSION, } from './common';
// Extension vulnerabilities (sheet rows 95, 96).
const OPTIONAL = new Set(['summary', 'fix']);
/**
 * V1 (the extension itself) and V2 (a declared dependency). Needs
 * `alert_source_details`; flag off renders the static copy (decision 9).
 */
export function resolveExtensionVulnerability(alert) {
    const details = alert.sourceDetails;
    const osv = details?.kind === 'extension' ? details.osvComponent : undefined;
    const variant = osv?.subject === 'extension'
        ? 'V1'
        : osv?.subject === 'dependency'
            ? 'V2'
            : null;
    const copy = riskCopy(`extensionsPackagesOsvDetection::osv_vulnerability#${variant ?? 'V1'}`);
    const advisoryId = present(osv?.cveId) ??
        present(details?.kind === 'extension' ? details.osvId : undefined);
    if (osv == null || variant == null || advisoryId == null) {
        return fallbackOf(copy);
    }
    const version = present(osv.version);
    const checked = version != null && version !== UNKNOWN_VERSION;
    const extension = variant === 'V1' ? present(osv.name) : sourceField(details, 'name');
    let template = copy.whatHappened.replace('{: summary}', '{summary}');
    if (extension == null) {
        template = template.replace('The extension {extension}', 'An extension');
    }
    if (!checked) {
        template =
            variant === 'V1'
                ? template.replace(' Kirin checked version {version}.', '')
                : template.replace('Kirin checked version {version}, which is affected by', 'It is affected by');
    }
    const name = present(osv.name);
    if (variant === 'V2' && name == null) {
        return fallbackOf(copy);
    }
    const fixedVersion = present(osv.fixedVersion);
    const summary = summaryClause(osv.summary);
    const what = fillRiskTemplate(template, {
        extension,
        name,
        version,
        advisoryId,
        summary,
    }, OPTIONAL);
    const why = fillRiskTemplate(copy.whyItMatters, {
        fix: checked &&
            fixedVersion != null &&
            isNewerVersion(fixedVersion, version, osv.ecosystem)
            ? `; version ${fixedVersion} includes a fix`
            : '',
    }, OPTIONAL);
    return partsOf(copy, what == null ? null : closeSentence(what, summary), why);
}
//# sourceMappingURL=extensions.js.map